export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Card"] = "card";
    PaymentMethodType["ACH"] = "us_bank_account";
})(PaymentMethodType || (PaymentMethodType = {}));
//# sourceMappingURL=types.js.map